export default "__VITE_ASSET__Cvky$q9n__"